<router-outlet />
<app-toast-container />
<app-build-version-badge />
